import { render, staticRenderFns } from "./DebtorAdjustmentRevenueTotals.vue?vue&type=template&id=61209a14&scoped=true"
import script from "./DebtorAdjustmentRevenueTotals.vue?vue&type=script&lang=js"
export * from "./DebtorAdjustmentRevenueTotals.vue?vue&type=script&lang=js"
import style0 from "./DebtorAdjustmentRevenueTotals.vue?vue&type=style&index=0&id=61209a14&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61209a14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61209a14')) {
      api.createRecord('61209a14', component.options)
    } else {
      api.reload('61209a14', component.options)
    }
    module.hot.accept("./DebtorAdjustmentRevenueTotals.vue?vue&type=template&id=61209a14&scoped=true", function () {
      api.rerender('61209a14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/debtoradjustment/DebtorAdjustmentRevenueTotals.vue"
export default component.exports